import ShoppingListContainer from "@/components/ShoppingList/ShoppingListContainer";
import CategoryPage from "@/src/categories/components/CategoryPage";
import getCategoryStaticProps from "@/src/categories/lib/getCategoryStaticProps";
import type CategoryGroup from "@/src/categories/types/CategoryGroup";
import Head from "next/head";
import { Seomatic } from "react-seomatic";

export const getStaticPaths = async () => {
  return {
    paths: [],
    fallback: "blocking",
  };
};

export async function getStaticProps({ params }) {
  const group = params.group as CategoryGroup;

  const categoryPageProps = await getCategoryStaticProps({
    group,
    slug: params.slug,
    pageNumber: params.pageNumber,
  });

  return categoryPageProps;
}

const CategoryPagePage = ({
  pageEntry,
  category,
  recipes,
  pageCount,
  pageNumber,
}) => {
  return (
    <>
      <Seomatic Head={Head} {...category.seomatic} />
      <ShoppingListContainer />

      <CategoryPage
        pageEntry={pageEntry}
        category={category}
        recipes={recipes}
        pageCount={pageCount}
        pageNumber={pageNumber}
      />
    </>
  );
};

export default CategoryPagePage;
